import { IndianStates } from "../../Types";
import { ApiUtility, IApiResponse } from "../../Utilities/ApiUtility.axios";
import { GSTTableType } from "../Pages/Reports/GSTReports/GSTReports";
import { Languages } from "./GeneralSettingService";
import {
  IIdNameModel,
  IItemInvCloOpResponse,
  Item_Nature,
  UnitTypes,
} from "./ItemsService";
import {
  Duty_Type,
  NewCompanyGstType_new,
  TypeOfAddress,
} from "./LedgerService";
import {
  Discount_Policy,
  IGstShort,
  RoundOff_Type,
  TimeUnits,
} from "./SettingService";
import { Transaction_Type } from "./TdsTcsServices";

export interface IIdNameDateModel {
  id: string;
  name: string;
  date: string;
}
export interface IClosingEntryResponseModel {
  closingVouchers: IClosingEntryItems[];
  itemsClosingInvDetail?: IItemInvCloOpResponse[];
}
export interface IClosingEntryItems {
  entryType: ClosingEntry_Type;
  voucher: IVoucherModel;
}
export interface IVoucherModel {
  number?: string;
  isCustomNumber?: boolean;
  isGSTVoucher?: boolean;
  isAssetVoucher?: boolean;
  supplierInvoiceRef?: string;
  supplierInvoiceDate?: string;
  eInvoiceId?: string;
  eInvoiceDate?: string;
  date: string;
  dueDate: string;
  purchaseOrderRef?: IIdNameDateModel;
  returnNoteType?: ReturnNote_Type;
  effectiveLedger: ITransactionLedgerDetail[];
  partyLedger: ITransactionLedgerDetail[];
  statutoryLedgers?: ITransactionLedgerDetail[];
  freightInsLedgers?: ITransactionLedgerDetail[];
  isCashVoucher?: boolean;
  bankImportEntryRef?: string;
  voucherType: Voucher_Type;
  voucherTitle?: {
    id: number;
    name: string;
  };
  billingAddress?: IVoucherAddressModel;
  isShippingAddressSame?: boolean;
  shippingAddress?: IVoucherAddressModel;
  contactName?: string;
  contactNo?: string;
  isStateSame?: boolean;
  despatchDetail?: IDespatchDetailModel;
  pan?: string;
  partyGSTIN?: string;
  nature?: Voucher_Nature;
  exportDetail?: IExportDetailModel;
  items?: IItemDetailModel[];
  AssetItems?: IAssetItemDetailModel[];
  freightType?: Freight_Type;
  currency?: IIdNameModel;
  conversionRate?: number;
  underLUT?: boolean;
  tdsApplicable?: boolean;
  tdsDetail?: ITDSTCSDetailModel;
  tcsApplicable?: boolean;
  tcsDetail?: ITDSTCSDetailModel;
  // cessDetail?: any;
  amountSummary?: INewVoucherAmountDetails;
  payStatus?: PaymentStatus_New;
  payRecReference?: string;
  instantPayment?: boolean;
  narration?: string;
  termsNConditions?: {
    templateId?: string;
    tnCText?: string;
  };
  supplyState?: IndianStates;
  billState?: IndianStates;
  voucherStatus?: VoucherStatus_New;
  orderStatus?: OrderStatus;
  taxSummary?: ITaxSummaryShortModel;
  gstReportType?: GSTReport_Type;
  gstSupplyType?: GSTTableType;
  partyGSTType?: NewCompanyGstType_new;
  gstStatus?: GSTVoucher_Status;
  language?: Languages;
  isLocked?: boolean;
  isGSTReturnFiled?: boolean;
  isAmendedAfterGSTReturn?: boolean;
  amendedAfterGSTReturnCount?: number;
  isReconciled?: ReconciledFilter;
  mode?: VoucherMode;
  isAudited?: boolean;
  isActive?: boolean;
  deleteUploadId?: string[];
  attachments?: IFileNameModel[];
}
export interface IFileNameModel {
  id?: string;
  name?: string;
  contentType?: string;
  length?: number;
  path?: string;
}
export interface ITaxSummaryShortModel {
  taxDetail?: ITaxSummary[];
  grandTaxableAmount?: number;
  grandIGSTAmount?: number;
  grandCGSTAmount?: number;
  grandSGSTAmount?: number;
  grandTotalAmount?: number;
}
export interface ITaxSummary {
  typeOfDuty?: Duty_Type;
  typeOfITC?: ITC_Type;
  hsnsac?: string;
  taxableAmount?: number;
  taxRate?: number;
  igstRate?: number;
  igstAmt?: number;
  cgstRate?: number;
  cgstAmt?: number;
  sgstRate?: number;
  sgstAmt?: number;
  cessRate?: number;
  cessAmt?: number;
  surchargeRate?: number;
  surchargeAmt?: number;
  tcsRate?: number;
  tcsAmt?: number;
  otherTaxRate?: number;
  otherTaxAmt?: number;
  totalTaxAmt?: number;
}
export interface INewVoucherAmountDetails {
  totalCIFGSTAmt?: number;
  totalItemGSTAmt?: number;
  suppliedQty?: number;
  totalQty?: number;
  taxableAmount?: number;
  totalDis?: number;
  cifExpenses?: number;
  cessRate?: number;
  cessAmount?: number;
  otherTaxRate?: number;
  otherTaxAmount?: number;
  igstAmt?: number;
  cgstAmt?: number;
  sgstAmt?: number;
  tcsRate?: number;
  tcsAmt?: number;
  tcsPaidAmt?: number;
  tdsRate?: number;
  tdsAmt?: number;
  tdsPaidAmt?: number;
  totalInvoiceAmount?: number;
  receivedAmountRef?: IRefModel[];
  refundAmount?: number;
  receivedAmount?: number;
  dueAmount?: number;
  roundOff?: {
    roundOffApplicable?: boolean;
    roundOffAmount?: number;
  };
  cashDiscount?: {
    discountRate?: number;
    discountAmount?: number;
  };
  voucherAmountWithoutTCS?: number;
  totalInvoiceAmountInWords?: string;
}
export interface ITDSTCSDetailModel extends IIdNameModel {
  value?: number;
  rate?: number;
  transactionType?: Transaction_Type;
  form?: string;
}
export interface IAssetItemDetailModel {
  id: string;
  name: string;
  isTaxable?: boolean;
  amount?: IItemAmountSummary;
  itcEligibilityType?: ITCEligibility_Type;
  residualValue?: number;
  warrantyExpDate?: string;
  identityCode?: string;
  description?: string;
  depreciationStartDate?: string;
  depreciationLastDate?: string;
  voucherRefs?: IVoucheerRefModel[];
}
export interface IItemAmountSummary {
  discount?: number;
  discountRupee?: number;
  grossAmount?: number;
  totalAmount?: number;
  price?: number;
  suppliedQty?: number;
  returnedQty?: number;
  qty?: number;
  tax?: IGstShort;
  itemTaxAmt?: number;
  unit?: IIdNameUnitModel;
}
export interface IIdNameUnitModel {
  id: number;
  name: number;
  shortName?: string;
  unitType?: UnitTypes;
}
export interface IItemDetailModel {
  id: string;
  name: string;
  isService?: boolean;
  isTaxable?: boolean;
  amount?: IItemAmountSummary;
  itcEligibilityType?: ITCEligibility_Type;
  description?: string;
  hsnsac?: string;
  trackingType?: Item_Nature;
  voucherRefs?: IVoucheerRefModel[];
  noPackages?: number;
}
export interface IExportDetailModel {
  vesselNo?: string;
  shipDocNo?: string;
  shipDate?: string;
  loadingPort?: string;
  dischargePort?: string;
  blNumber?: string;
  transportMode?: Transport_Mode;
  insuranceDetail?: {
    policyNo?: string;
    policyDate?: string;
    insuranceValue?: number;
  };
}
export interface IDespatchDetailModel {
  delNoteNo?: string;
  delNoteDate?: string;
  desDocNo?: string;
  transporterCoName?: IIdNameModel;
  transporterOwnerName?: string;
  vehicleNo?: string;
  driverName?: string;
  driverContactNo?: string;
  destination?: string;
}
export interface IVoucherAddressModel {
  address?: string;
  addressName?: string;
  country?: string;
  type?: TypeOfAddress;
}
export interface ITransactionLedgerDetail {
  id: string;
  ledgerName: string;
  description: string;
  amount: number;
  taxableAmount: number;
  gstRate: IGSTShort;
  hsnsac: string;
  addAmount: boolean;
  gstAmount: number;
  tdsAmount: number;
  fullAmountParentLedgerId: string;
  fullAmount: number;
  tempParkedLedger: boolean;
  totalAmount: number;
  transactionId: string;
  isRCM: boolean;
  isDebitNature: boolean;
  partyOrTax: Party_Tax;
  isBankLedger: boolean;
  typeOfDuty: Duty_Type;
  itcEligibilityType: ITCEligibility_Type;
  openingEntryCategory: OpeningEntry_Categories;
  ref: IRefModel[];
  costCentresDetail?: ICostCentreModel[];
}
export interface IVoucheerRefModel {
  id?: string;
  name?: string;
  qty?: number;
  amount?: number;
}
export interface ICostCentreModel {
  id: string;
  name?: string;
  value: number;
  qty?: number;
}

export interface IRefModel {
  id: string;
  name: string;
  value: number;
  refType: RefType;
  parentRef?: string;
  debitNature?: boolean;
  fullAmount?: number;
  fullAmountLedger?: string;
  fullAmountLedgerAmount?: number;
  dueAmount?: number;
  totalAmount?: number;
  date?: string;
}

export interface IGSTShort {
  id: number;
  name: string;
  rate: number;
}
export enum GSTReport_Type {
  Unspecified,
  GSTR1,
  GSTR2A = 21,
  GSTR2B,
  GSTR2C,
  GSTR3B = 31,
  GSTR4 = 41,
  GSTR5 = 51,
  GSTR6 = 61,
  GSTR7 = 71,
  GSTR8 = 81,
  GSTR9 = 91,
}
export enum GSTVoucher_Status {
  NotSubmitted,
  Submitted,
  Rejected,
  Claimed,
}
export enum ITC_Type {
  Add,
  Reversal,
  None,
}

export enum PaymentStatus_New {
  Due,
  Overdue,
  Paid,
  Refund,
}
export enum ReturnNote_Type {
  against,
  fresh,
}
export enum ClosingEntry_Type {
  ExpensesnIncome,
  AssetsnLiabities,
}
export enum VoucherMode {
  Normal,
  Opening,
  Closing,
}
export enum Party_Tax {
  other,
  party,
  tax,
  BanknCash,
  TangibleFixedAsset,
  Depreciation,
  RoundOff,
  Discount,
  CC,
  BadDebts,
  AccumulatedDepreciation,
  Stock,
  Capital,
}
export enum Voucher_Type {
  All,
  SalesVoucher,
  CreditNote,
  PurchaseVoucher,
  DebitNote,
  Payment,
  Receipt,
  Contra,
  PurchaseOrder,
  SalesOrder,
  Journal,
  Quotation,
  ExportInvoice,
  DeemedExportInvoice,
  SEZInvoice,
  ExportBill,
  DeemedExportBill,
  SEZBill,
  RCMBill,
  ExpenseJV,
  DChallan,
  RChallan,
  Asset,
  StockVoucher,
  Requisition,
  Expenses,
  Income,
  PInvoice,
  DisposedAsset,
}
export enum ReconcileTypes {
  Both,
  Reconciled,
  Nonreconciled,
}

export enum LedgerTypes {
  All,
  PartiesOnly,
  PartiesWithBank,
  BankAndCash,
  Sales,
  Purchase,
  DirectExpenses,
  IndirectExpenses,
  PaymentIn,
  PaymentOut,
  DutiesAndTaxes,
}
export enum VoucherFilterStatus {
  All,
  Active,
  Due,
  Overdue,
  Paid,
  Deleted,
  Draft,
}
export enum OrderStatus {
  All,
  Pending,
  Completed,
  Deleted,
  Draft,
}

export const OrderStatusList = [
  { label: "All", value: OrderStatus.All },
  { label: "Pending", value: OrderStatus.Pending },
  { label: "Completed", value: OrderStatus.Completed },
  { label: "Deleted", value: OrderStatus.Deleted },
  { label: "Draft", value: OrderStatus.Draft },
];

export enum VoucherStatus_New {
  Active,
  Deleted,
}

export enum AddressEnum {
  BillingAddress,
  ShippingAddress,
}

export enum RefType {
  newRef,
  AgnstRef,
}

export enum ReconciledFilter {
  both,
  reconciled,
  nonreconciled,
}

export enum Freight_Type {
  EXW = 1,
  FOB,
  CIF,
  CFR,
  FCA,
  CPT,
  CIP,
  DAP,
  DPU,
  DDP,
  FAS,
}

export const FreightTypeOptions = [
  { value: Freight_Type.EXW, label: "Ex-Works" },
  { value: Freight_Type.FOB, label: "Free on Board" },
  { value: Freight_Type.CIF, label: "Cost, Insurance and Freight" },
  { value: Freight_Type.CFR, label: "Cost and Freight" },
  { value: Freight_Type.FCA, label: "Free Carrier" },
  { value: Freight_Type.CPT, label: "Carriage Paid to" },
  { value: Freight_Type.CIP, label: "Carriage and Insurance Paid To" },
  { value: Freight_Type.DAP, label: "Delivered at Place" },
  { value: Freight_Type.DPU, label: "Delivered at Place Unloaded" },
  { value: Freight_Type.DDP, label: "Delivered Duty Paid" },
  { value: Freight_Type.FAS, label: "Free Alongside Ship" },
];

export enum OpeningEntry_Categories {
  none,
  customer,
  supplier,
  fixedAssets,
  stock,
  otherThanFixedAssets,
  liability,
  cashBank,
  capital,
}

export enum ITCEligibility_Type {
  Available,
  UnvailableUOther,
  UnavailableUs17_5,
}

export const ITCEligibilityTypeOptions = [
  {
    value: ITCEligibility_Type.Available,
    label: "Eligible for ITC",
    title: "",
  },
  {
    value: ITCEligibility_Type.UnvailableUOther,
    label: "Ineligible - Other",
    title: "",
  },
  {
    value: ITCEligibility_Type.UnavailableUs17_5,
    label: "Ineligible - u/Sec. 17(5)",
    title: "",
  },
];

export enum RCMFilter {
  Both,
  RCM,
  NonRCM,
}

export const RCMFilterOptions = [
  { value: RCMFilter.Both, label: "RCM / Non-RCM" },
  { value: RCMFilter.RCM, label: "RCM" },
  { value: RCMFilter.NonRCM, label: "Non RCM" },
];

export enum Transport_Mode {
  ByRoad,
  ByAir,
  ByOcean,
}

export const Transport_ModeOptions = [
  { value: Transport_Mode.ByRoad, label: "By Road" },
  { value: Transport_Mode.ByAir, label: "By Air" },
  { value: Transport_Mode.ByOcean, label: "By Ocean" },
];

export enum CashCreditFilter {
  All,
  CashOnly,
  CreditOnly,
}

export const CashCreditFilterOptions = [
  { value: CashCreditFilter.All, label: "Cash / Credit" },
  { value: CashCreditFilter.CashOnly, label: "Cash Only" },
  { value: CashCreditFilter.CreditOnly, label: "Credit Only" },
];

export enum PeriodRange {
  Unspecified,
  Today,
  Yesterday,
  CurrentWeek,
  LastWeek,
  ThisMonth,
  LastMonth,
  //ThisYear,
  //LastYear
}
export enum Voucher_Nature {
  Regular,
  RCM,
  //B2C,
  //B2B,
  ImportExport,
  DeemedExport,
  SEZ,
}
export const voucherNatureOptions = [
  { label: "Regular", value: Voucher_Nature.Regular, title: "" },
  { label: "Export/Import", value: Voucher_Nature.ImportExport, title: "" },
  {
    label: "Deemed Export/Import",
    value: Voucher_Nature.DeemedExport,
    title: "",
  },
  { label: "SEZ", value: Voucher_Nature.SEZ, title: "" },
  { label: "Reverse Charge (RCM)", value: Voucher_Nature.RCM, title: "" },
];

export const addVoucherNatureOptions = {
  label: "Reverse Charge (RCM)",
  value: Voucher_Nature.RCM,
};

export const expensesIncomeNatureOptions = [
  { label: "Regular", value: Voucher_Nature.Regular },
];

export const addVoucherExpensesIncomeptions = {
  label: "Reverse Charge (RCM)",
  value: Voucher_Nature.RCM,
};

export const convertToDays = (duration: number, durationUnit?: TimeUnits) => {
  let days;
  if (duration <= 0) {
    return 0;
  } else {
    switch (durationUnit) {
      case TimeUnits.Day:
        days = duration;
        break;
      case TimeUnits.Week:
        days = duration * 7;
        break;
      case TimeUnits.Month:
        days = duration * 30; // Approximation, adjust as necessary
        break;
      case TimeUnits.Year:
        days = duration * 365; // Approximation, adjust as necessary
        break;
      default:
        throw new Error("Invalid duration unit");
    }
    return days;
  }
};

export enum DiscountType {
  NoDiscount,
  PercentageDiscount,
  RupeeDiscount,
}

export interface PriceHistoryByItemIdResponse {
  voucherId: string;
  voucherNumber: string;
  partyName: string;
  voucherDate: string;
  items?: PriceHistoryItemDetail[];
  expenses?: PriceHistoryExpensesDetail[];
}
interface PriceHistoryItemDetail {
  itemId: string;
  itemName: string;
  itemQty: number;
  itemPrice: number;
}
interface PriceHistoryExpensesDetail {
  expenseId: string;
  expenseName: string;
  expensePrice: number;
}

export interface VoucherSettingControl {
  title?: string;
  templateId: number;
  titleToBePrint?: string;
  showContactDetail: boolean;
  discountPolicy: Discount_Policy;
  showReceipt: boolean;
  showOtherCharges: boolean;
  showShippingAddress: boolean;
  showItemDescription: boolean;
  autoRoundOff: boolean;
  showPriceHistory: boolean;
  roundOffType: RoundOff_Type;
  showDispatchDetail: boolean;
  showFreightType: boolean;
  showRCM: boolean;
  showTcs: boolean;
  showTds: boolean;
  defaultNature: Voucher_Nature;
}

export enum AssetVoucherFilter {
  both,
  nonAssets,
  assets,
}
class VoucherService {
  route = `V1/API/Billing/Acc_New_Voucher`;

  //localhost:7142/v1/API/Acc_New_Voucher/65cdd05235241f48a55de738/GetVoucherListByPartyId?voucherType=2&voucherType=660a7f238413a5a73dd8ca11

  getVoucherListByPartyId = (
    companyId: string,
    voucherType: Voucher_Type,
    partyId: string
  ) =>
    ApiUtility.get(`${this.route}/${companyId}/GetVoucherListByPartyId`, {
      voucherType,
      partyId,
    });

  // GetMaxVoucherDate;
  // https://localhost:7142/v1/API/Acc_New_Voucher/6646e10e5038e585a6b5e816/GetMaxVoucherDate?voucherType=1
  getMaxVoucherDate = (companyId: string, voucherType: Voucher_Type) =>
    ApiUtility.get(`${this.route}/${companyId}/GetMaxVoucherDate`, {
      voucherType,
    });

  // GetPriceHistoryByItemId;
  // https://localhost:7142/v1/API/Acc_New_Voucher/6646e10e5038e585a6b5e816/GetPriceHistoryByItemId?voucherType=1,ItemId='6646e10e5038e585a6b5e816'
  getPriceHistoryByItemId = (
    companyId: string,
    voucherType: Voucher_Type,
    ItemId: string,
    SearchForItem: boolean
  ) =>
    ApiUtility.get<IApiResponse<PriceHistoryByItemIdResponse[]>>(
      `${this.route}/${companyId}/GetPriceHistoryByItemId`,
      {
        voucherType,
        ItemId,
        SearchForItem,
      }
    );

  // https: //localhost:7142/v1/API/Acc_New_Voucher/65cdd05235241f48a55de738/GetVoucherMaxNo?voucherType=1
  //get party vise references max no
  getVoucherMaxNo = (
    companyId: string,
    voucherType: Voucher_Type,
    voucherDate: any,
    templateId: number
  ) =>
    ApiUtility.get(
      `${this.route}/${companyId}/GetVoucherMaxNo?voucherType=${voucherType}`,
      {
        templateId,
        voucherDate,
      }
    );

  //https://localhost:7142/v1/API/Acc_New_Voucher/65cdd05235241f48a55de738/GetReferencesByParty?partyId=65d74367983b0a7e7dda7721

  // get party vise references
  getReferencesByParty = (
    companyId: string,
    partyId: string,
    voucher_Type: Voucher_Type
  ) =>
    ApiUtility.get(`${this.route}/${companyId}/GetReferencesByParty`, {
      partyId,
      voucher_Type,
    });

  // // Download/CSV

  // exportCsv = (
  //   companyId: any,
  //   voucherType: Voucher_Type | any,
  //   from: string,
  //   to: string,
  //   start: number,
  //   length: number,
  //   sortCol?: string,
  //   sortDir?: string,
  //   partyId?: string,
  //   reconciled?: ReconcileTypes | any,
  //   search?: string,
  //   status?: VoucherFilterStatus
  // ) =>
  //   ApiUtility.downloadFile(`${this.route}/${companyId}/Download/CSV`, {
  //     voucherType,
  //     start,
  //     length,
  //     from,
  //     to,
  //     sortCol,
  //     sortDir,
  //     partyId,
  //     reconciled,
  //     search,
  //     status,
  //   });
  // public async Task<IActionResult> DownloadCSV(string companyId, Voucher_Type voucherType, int start = 0, int length = 15, string from = null, string to = null, string sortCol = "", string sortDir = "", string partyId = null, ReconciledFilter reconciled = ReconciledFilter.both, string search = "", VoucherFilterStatus status = VoucherFilterStatus.Active)

  //https://localhost:7142/v1/API/Acc_New_Voucher/65cdd05235241f48a55de738/GetList?voucherType=0&start=0&length=15&partyId=65d5a8435b08e02630da8017
  //https://localhost:7142/v1/API/Acc_New_Voucher/65cdd05235241f48a55de738/GetList?voucherType=0&start=0&length=15&from=20-03-2024&to=20-03-2024

  getVoucharList = (
    companyId: any,
    voucherType: Voucher_Type | any,
    from: string,
    to: string,
    start: number,
    length: number,
    sortCol?: string,
    sortDir?: string,
    partyId?: string,
    reconciled?: ReconcileTypes | any,
    search?: string,
    status?: VoucherFilterStatus,
    itemId?: string,
    // PeriodRange
    rCMFilter?: RCMFilter,
    cashCreditFilter?: CashCreditFilter,
    requestModel?: any,
    assetVoucherFilter?: AssetVoucherFilter,
    costCentreId?: string
  ) =>
    ApiUtility.get(`${this.route}/${companyId}/GetList`, {
      voucherType,
      from,
      to,
      start,
      length,
      sortCol,
      sortDir,
      partyId,
      reconciled,
      search,
      status,
      itemId,
      rCMFilter,
      cashCreditFilter,
      requestModel,
      assetVoucherFilter,
      costCentreId,
    });

  //https: //localhost:7142/v1/API/Acc_New_Voucher/65cdd05235241f48a55de738/65faa00a2200123bddd4a24e?voucherType=10

  // get Vouchar Id
  getVoucharById = (
    companyId: string | undefined,
    voucharId: string | undefined,
    voucherType?: Voucher_Type
  ) =>
    ApiUtility.get(`${this.route}/${companyId}/${voucharId}`, {
      voucherType,
    });

  //https://localhost:7142/v1/API/Acc_New_Voucher/65cdd05235241f48a55de738/65fd5954085e97708cd14693?voucherType=10
  // post Ledger Api

  postVoucher = (
    companyId: string | undefined,
    voucherType: Voucher_Type | undefined,
    params: any,
    id?: string
    // attachments?: any,
    // config?: string,
  ) =>
    ApiUtility.postForm(
      `${this.route}/${companyId}${
        id ? "/" + id : ""
      }?voucherType=${voucherType}`,
      params
      // config,
      // attachments,
    );

  // https: //localhost:7142/v1/API/Acc_New_Voucher/65cdd05235241f48a55de738/66211d2d3a14b834a3366c28
  // delete vouchar api
  deleteVoucher = (companyId: string | undefined, voucherId: string) =>
    ApiUtility.delete(`${this.route}/${companyId}/${voucherId}`);

  postReconcileVoucher = (companyId: string | undefined, reconciledData: any) =>
    ApiUtility?.post(
      `${this.route}/${companyId}/ReconcileVoucher`,
      reconciledData
    );

  postLockVoucherMonth = (
    companyId: string | undefined,
    LockMonth: string,
    LockType: boolean
  ) =>
    ApiUtility?.post(
      `${this.route}/${companyId}/PostLockVoucherMonth?LockMonth=${LockMonth}&LockType=${LockType}`,
      {}
    );
  getLockVoucherMonths = (companyId: string | undefined) =>
    ApiUtility?.get(`${this.route}/${companyId}/GetLockVoucherMonths`);

  // https://localhost:7142/v1/API/Acc_New_Voucher/6646e10e5038e585a6b5e816/OpeningEntry

  openingEntryGet = (companyId: string, date: string) =>
    ApiUtility.get(`${this.route}/${companyId}/OpeningEntry?date=${date}`);

  GetLastReconcileHistory = (companyId: string | undefined, ledgerId: string) =>
    ApiUtility.get(
      `${this.route}/${companyId}/LedgerId/${ledgerId}/GetLastReconcileHistory`
    );

  GetAllReconcileHistory = (
    companyId: string | undefined,
    ledgerId: string,
    fromDate: string,
    toDate: string
  ) =>
    ApiUtility.get(
      `${this.route}/${companyId}/LedgerId/${ledgerId}/GetAllReconcileHistory?fromDate=${fromDate}&toDate=${toDate}`
    );
  ShowClosingEntries = (companyId: string, from: string, to: string) =>
    ApiUtility.get<IApiResponse<IClosingEntryResponseModel>>(
      `${this.route}/${companyId}/ShowClosingEntries?from=${from}&to=${to}`
    );
  CreateClosingEntries = (
    companyId: string,
    from: string,
    to: string,
    closingEntryData: IClosingEntryResponseModel
  ) =>
    ApiUtility.post<IApiResponse<boolean>>(
      `${this.route}/${companyId}/CreateClosingEntries?from=${from}&to=${to}`,
      { ...closingEntryData }
    );
}
export default new VoucherService();
